import React, { useState } from "react";
import Form from "react-bootstrap/Form";
import InputGroup from "react-bootstrap/InputGroup";
import styles from "./cart.module.css";
import ToggleButtonGroup from "react-bootstrap/ToggleButtonGroup";
import axios from "axios";
import { useDispatch } from "react-redux";
import {
  removeItemFromCart,
  flushCart,
  addOrderToUser,
} from "../../redux/userSlice";
import { BsHandbag } from "react-icons/bs";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router";
import { BiLockAlt } from "react-icons/bi";
import { FaTrashAlt } from "react-icons/fa";
import CounterNoInput from "../QtyCounter/CounterNoInput";

function Cart() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const cart = useSelector((state) => state.cart);
  const user = useSelector((state) => state.user);
  const [paymentType, setPaymentType] = useState(null);
  const address = user.address;

  const handleSubmitPayment = async (e) => {
    e.preventDefault();
    try {
      if (cart.length === 0) {
        return console.log("carrito vacio");
      } else {
        const response = await axios({
          url: `${process.env.REACT_APP_API_PORT}/orders`,
          method: "POST",
          headers: {
            Authorization: `Bearer ${user.token}`,
          },
          data: {
            cart,
            paymentType,
            cartSubtotal,
            address,
          },
        });
        dispatch(flushCart());
        dispatch(addOrderToUser(response.data.order));
        navigate("/thanks");
      }
    } catch (error) {}
  };

  const cartSubtotal = cart.reduce(
    (acumulado, current) => acumulado + current.price * current.qty,
    0
  );

  return (
    <>
      <div className={styles.containerMayor}>
        <div className={styles.contenedor + " container bg-light rounded mb-5"}>
          <form onSubmit={(e) => handleSubmitPayment(e)}>
            <div className={styles.firstRow + " row"}>
              <div className="col-sm-12 col-lg-6 pt-3 pb-3">
                <h5 className={styles.text}>Información de Contacto</h5>

                <div className={styles.divEmail}>
                  <label htmlFor="" className="mb-1 text-muted">
                    Email
                  </label>
                  <InputGroup className="mb-2">
                    <Form.Control
                      aria-label="Email"
                      aria-describedby="basic-addon1"
                      readOnly="readonly"
                      value={user.email}
                    />
                  </InputGroup>
                </div>
                <div className={styles.divInfo + " container"}>
                  <div className="row">
                    <div className="col-12 mb-2">
                      <h5 className={styles.text}>Información de envío</h5>
                    </div>
                    <div className="row">
                      <div className="d-flex flex-column col-12 col-lg-6">
                        <label htmlFor="" className="text-muted">
                          Nombre
                        </label>
                        <InputGroup className="mb-3">
                          <Form.Control
                            aria-label="Nombre"
                            aria-describedby="basic-addon1"
                            readOnly="readonly"
                            value={user.firstname}
                          />
                        </InputGroup>
                      </div>
                      <div className="d-flex flex-column col-12 col-lg-6">
                        <label htmlFor="" className="text-muted">
                          Apellido
                        </label>
                        <InputGroup className="mb-3">
                          <Form.Control
                            aria-label="Apellido"
                            aria-describedby="basic-addon1"
                            readOnly="readonly"
                            value={user.lastname}
                          />
                        </InputGroup>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-12">
                        <label htmlFor="" className="text-muted">
                          Dirección
                        </label>
                        <InputGroup className="">
                          <Form.Control
                            aria-label="Dirección"
                            aria-describedby="basic-addon1"
                            value={address}
                            readOnly="readonly"
                            name="address"
                          />
                        </InputGroup>
                      </div>
                    </div>
                  </div>
                </div>

                <div className=" d-flex flex-column">
                  <h5 className={styles.text}>Método de pago</h5>
                  <div
                    className={
                      styles.divTypeCheck + " d-flex align-items-center"
                    }
                  >
                    <ToggleButtonGroup type="radio" name="options">
                      <Form.Check
                        type="radio"
                        id="radio1"
                        name="paymentType"
                        label="Tarjeta de Crédito"
                        value="card"
                        className=" text-muted m-3"
                        onChange={() => setPaymentType("card")}
                        required
                      />
                      <Form.Check
                        type="radio"
                        id="radio2"
                        required
                        name="paymentType"
                        label="Efectivo"
                        value="cash"
                        className=" text-muted m-3"
                        onChange={() => setPaymentType("cash")}
                      />
                    </ToggleButtonGroup>
                  </div>
                  {paymentType === "card" ? (
                    <div>
                      <div className="col-12">
                        <label htmlFor="" className="text-muted">
                          Número de Tarjeta
                        </label>
                        <InputGroup className="mb-3">
                          <Form.Control
                            aria-label="Número de Tarjeta"
                            aria-describedby="basic-addon1"
                            placeholder="XXXX-XXXX-XXXX-XXXX"
                          />
                        </InputGroup>
                      </div>
                      <div className="col-12">
                        <label htmlFor="" className="text-muted">
                          Nombre del titular
                        </label>
                        <InputGroup className="mb-3">
                          <Form.Control
                            aria-label="Nombre del titular"
                            aria-describedby="basic-addon1"
                            placeholder="John Doe"
                          />
                        </InputGroup>
                      </div>
                      <div className="col-12 ">
                        <div className="d-flex justify-content-between w-100">
                          <div>
                            <label htmlFor="" className="text-muted">
                              Fecha de vencimiento
                            </label>
                            <InputGroup className="mb-3">
                              <Form.Control
                                type="text"
                                aria-label="Fecha de Vencimiento"
                                aria-describedby="basic-addon1"
                                placeholder="MM/AAAA"
                              />
                            </InputGroup>

                            <div className="col-12 col-lg-6">
                              <label htmlFor="" className="text-muted">
                                CVC
                              </label>
                              <InputGroup className="mb-3">
                                <Form.Control
                                  maxLength="4"
                                  type="password"
                                  aria-label="CVC"
                                  aria-describedby="basic-addon1"
                                  placeholder="XXXX"
                                />
                              </InputGroup>
                            </div>
                          </div>
                          <div className="d-flex flex-column justify-content-center align-items-center flex-sm-row">
                            <img
                              className="p-1"
                              src="https://wslqncwadyyucstwuusp.supabase.co/storage/v1/object/public/page-resources/page-images/visa.jpg"
                              alt=""
                            />
                            <img
                              className="p-1"
                              src="https://wslqncwadyyucstwuusp.supabase.co/storage/v1/object/public/page-resources/page-images/mastercard.jpg"
                              alt=""
                            />
                            <img
                              className="p-1"
                              src="https://wslqncwadyyucstwuusp.supabase.co/storage/v1/object/public/page-resources/page-images/amex.jpg"
                              alt=""
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  ) : (
                    <></>
                  )}
                </div>
              </div>

              <div className="col-sm-12 col-lg-6">
                <h5 className={styles.text + " pt-3"}>Resumen del Pedido</h5>

                <div className="d-flex flex-column">
                  <div className="mb-4">
                    {cart.length === 0 ? (
                      <div className={styles.emptyCart}>
                        <BsHandbag className={styles.cartIconOffCanvas} />
                        <h4 className="fs-5 text-center">
                          Su carrito está vacío
                        </h4>
                        <p className="fs-6 text-muted mt-2 text-center">
                          Llená el carrito y date un gustito!
                        </p>
                      </div>
                    ) : (
                      <>
                        {cart.map((product, index) => (
                          <div
                            key={index}
                            className={styles.cartItem + " d-flex"}
                          >
                            <div>
                              <img
                                className={styles.itemImage}
                                src={product.image}
                                alt="item"
                              />
                            </div>
                            <div className="w-100 d-flex flex-column justify-content-between mx-2 p-1">
                              <div className="d-flex justify-content-between mt-1">
                                <div className="d-flex flex-column">
                                  <h6
                                    className={
                                      styles.text + " fw-semibold mb-0"
                                    }
                                  >
                                    {product.name}
                                  </h6>
                                  <small className="text-muted mb-0">
                                    Cantidad: {product.qty}
                                  </small>
                                </div>

                                <h6 className=" text-muted fw-semibold">
                                  $ {product.price * product.qty}
                                </h6>
                              </div>
                              <div className="d-flex justify-content-between align-items-end">
                                <CounterNoInput product={product} />
                                <button
                                  className={styles.btnRemove}
                                  onClick={() =>
                                    dispatch(
                                      removeItemFromCart({
                                        name: product.name,
                                      })
                                    )
                                  }
                                >
                                  <FaTrashAlt />
                                </button>
                              </div>
                            </div>
                          </div>
                        ))}
                      </>
                    )}
                  </div>
                  <div className={styles.amounts + " col-6 w-100"}>
                    <div className="d-flex justify-content-between mt-3 mb-3">
                      <small className="fw-bold text-muted">Subtotal </small>
                      <small className="fw-bold text-muted">
                        $ {cartSubtotal}
                      </small>
                    </div>
                    <div
                      className={
                        styles.divEnvio +
                        " d-flex justify-content-between mt-3 mb-3"
                      }
                    >
                      <small className="fw-bold text-muted">Envío </small>
                      <small className="fw-bold text-muted">$ 50</small>
                    </div>
                    <div className="d-flex justify-content-between mt-4 mb-3">
                      <small className={styles.text + " fw-bold fs-5"}>
                        Total{" "}
                      </small>
                      <small className={styles.text + " fw-bold fs-5"}>
                        $ {cartSubtotal + 50}
                      </small>
                    </div>
                  </div>
                </div>

                <button type="submit" className={styles.btnCheckout}>
                  Confirmar pago
                  <BiLockAlt
                    style={{
                      fontSize: "1.1rem",
                      marginBottom: "2px",
                      marginLeft: "3px",
                    }}
                  />
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </>
  );
}

export default Cart;
